// extracted by mini-css-extract-plugin
export default {"list":"styles_list__9iZts","element":"styles_element__Kbf1r"};